<template>
  <div class="lg:ml-5 justify-content-around py-2 gap-2">
    <Breadcrumb
      :home="home"
      :model="breadcrumbItems"
    />
    <WikiGuideComponent @loaded="onGuideLoaded" />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import WikiGuideComponent from '@/components/wiki/WikiGuideComponent.vue';

const guideData = ref(null);

const home = ref({
  icon: 'pi pi-home',
  url: '/Warehouse',
});

const breadcrumbItems = computed(() => [
  { label: 'Wiki', url: '/wiki/items' },
  { label: guideData.value?.title ?? 'Guide', url: '' },
]);

function onGuideLoaded(guide) {
  guideData.value = guide;
}
</script>

<style scoped></style>
